import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialPrecoProdutosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  precoProdutoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const precoProdutosSlice = createSlice({
  name: "precoProdutos",
  initialState: initialPrecoProdutosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPrecoProdutoById
    tipoPrecoProdutoFetched: (state, action) => {
      state.actionsLoading = false;
      // APLICAR A MASCARA
      state.precoProdutoForEdit = action.payload.tipoPrecoProdutoForEdit;
      state.error = null;
    },
    // findPrecoProdutos
    precoProdutosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createPrecoProduto
    tipoPrecoProdutoCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.tipoPrecoProduto);
    },
    // updatePrecoProduto
    tipoPrecoProdutoUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.tipoPrecoProduto.idPrecoProduto) {
          return action.payload.tipoPrecoProduto;
        }
        return entity;
      });
    },
    // deletePrecoProduto
    tipoPrecoProdutoDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletePrecoProdutos
    precoProdutosDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // precoProdutosUpdateState
    precoProdutosStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
